"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _CatchFromControl = require("../CatchFromControl");
var _VariantInput = _interopRequireDefault(require("../VariantInput"));
var _RangeInput = _interopRequireWildcard(require("./RangeInput"));
var _styles = require("@mui/styles");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "classes", "input", "inputProps", "label", "variant", "value", "borderStyle", "onChange"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = "Range";
var Range = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    classes = props.classes,
    input = props.input,
    inputProps = props.inputProps,
    label = props.label,
    variantProps = props.variant,
    value = props.value,
    borderStyle = props.borderStyle,
    onChange = props.onChange,
    other = _objectWithoutProperties(props, _excluded);
  var muiFormControl = (0, _CatchFromControl.useFormControl)();
  var variant = muiFormControl ? muiFormControl.variant : variantProps;
  var stringInputValue = (0, _RangeInput.getRangeValue)(value);
  var InputComponent = /*#__PURE__*/(0, _jsxRuntime.jsx)(_VariantInput["default"], {
    label: label,
    borderStyle: borderStyle
  });
  var handleChange = (0, _react.useCallback)(function (e) {
    var rangeValue = (0, _RangeInput.parseRangeValue)(e.target.value);
    onChange({
      persist: function persist() {},
      target: _objectSpread(_objectSpread({}, e.target), {}, {
        name: props.name,
        value: rangeValue
      })
    });
  }, [onChange]);
  return /*#__PURE__*/(0, _react.cloneElement)(InputComponent, _objectSpread({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    value: stringInputValue,
    inputComponent: _RangeInput["default"],
    "data-cy": dataCy,
    inputProps: _objectSpread(_objectSpread({
      children: children,
      variant: variant,
      type: "number"
    }, inputProps), {}, {
      classes: inputProps ? (0, _styles.mergeClasses)({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref,
    onChange: handleChange
  }, other));
});
var _default = exports["default"] = Range;